<template>
  <div id="app">
    
  </div>
</template>

<script>
import {
  mapActions, mapGetters
} from 'vuex'

export default {
  name: 'FilePondDemo',
  data: function () {
    return {
      token: this.$route.query.token,
      client: this.$route.query.client,
    }
  },
  async mounted() {
    console.log('token', this.token);
    await this.loginBypass({token: this.token, client: this.client})
  },
  components: {
  },
  methods: {
    ...mapActions(['loginBypass']),
    handleFilePondInit() {

    }
  }
}
</script>

<style scoped></style>
